var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryPayAsYouGoTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.79167V11.6667M12.5 11.6667V13.5417M12.5 11.6667H10.625M12.5 11.6667H14.375M12.2305 6.15105C11.405 4.36457 9.59724 3.125 7.49999 3.125C4.62351 3.125 2.29166 5.45685 2.29166 8.33333C2.29166 11.1634 4.54893 13.4663 7.36131 13.5398M17.7083 11.6667C17.7083 14.5432 15.3765 16.875 12.5 16.875C10.2838 16.875 8.39091 15.4908 7.63867 13.5398C7.41453 12.9586 7.29166 12.327 7.29166 11.6667C7.29166 8.83658 9.54891 6.53365 12.3613 6.46014C12.4074 6.45894 12.4537 6.45833 12.5 6.45833C15.3765 6.45833 17.7083 8.79017 17.7083 11.6667Z",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryPayAsYouGoTransaction);
export default __webpack_public_path__ + "static/media/history_pay_as_you_go_transaction.73428304d7794647a3b96ce05b9fcf2d.svg";
export { ForwardRef as ReactComponent };